import e from "./validation-errors.strings.js";
import r from "./buttons.strings.js";
import o from "./app-launcher.strings.js";
import t from "./topbar.strings.js";
function s(e, r, o) {
  return r in e ? Object.defineProperty(e, r, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = o, e;
}
var i,
  a = {
    lng: "en",
    joinArrays: "\n",
    resources: {
      en: {
        translation: (s(i = {
          "app-launcher": o,
          topbar: t,
          "validation-errors": e,
          buttons: r,
          username: "username",
          password: "password",
          subdomain: "subdomain",
          "paginator.showing": "Showing",
          "paginator.items": "items",
          of: "of",
          "log-in": "Log in",
          "log-out": "Log Out",
          "log-in-with-itc": "Log in with KaseyaOne",
          "forgot-password": "Forgot password?",
          "forgot-password-instructions-1": "Enter your email, and we will send",
          "forgot-password-instructions-2": "you a link to reset your password.",
          "password-reset-sent": "An email with a password reset link has been sent to you.",
          "my-settings": "My Settings",
          "remember-me": "Remember me",
          "back-to-login": "Back to Login",
          "email-sent": "Email Sent",
          "mfa-code": "MFA Code",
          more: "More",
          "help-and-support": "Help & Support",
          ok: "OK",
          or: "Or",
          selected: "selected",
          reset: "Reset"
        }, "selected", "{{count}} selected"), s(i, "file-uploader", {
          reasons: {
            size: "File is too big. Max file size is {{limit}} MB.",
            type: "You can't upload files of this type.",
            other: "File could not be processed"
          },
          "upload-error": "{{type}} Errors ({{count}})",
          "max-file-size": "Max file size {{maxSize}} MB each",
          "size-errors": "Size Errors",
          "type-errors": "Type Errors",
          "other-errors": "Other Errors"
        }), s(i, "vault", "Vault"), s(i, "unsupported-browser", {
          title: "Unsupported Browser",
          description1: "Some features may not work as intended based on your current detected browser.",
          description2: "Here are some great alternatives:"
        }), s(i, "video-tutorials", "Video Tutorials"), s(i, "itc-searchbar-placeholder", "Search or filter by keywords..."), s(i, "all", "All"), s(i, "video-results", "{{dataLength}} of {{dataLength}} Results"), s(i, "view-in-new-tab", "Open in Vimeo"), s(i, "back-to-tutorials", "Back to Tutorials"), s(i, "suggested-videos", "Suggested Videos"), i)
      }
    }
  };
export { a as default };